@forward './config/breakpoints';
@forward './config/colors';
@forward './config/variables';
@forward './config/mixins';

@use 'sass:string';
@use './config/colors' as colors;
@use './config/breakpoints' as breakpoints;
@use './config/variables' as variables;

:export {
  colorPrimary: colors.$color-primary;
  colorPrimaryLight: colors.$color-primary-light;
  colorSecondary: colors.$color-secondary;
  colorSecondaryLight: colors.$color-secondary-light;
  colorDefault: colors.$color-default;
  colorBorder: colors.$color-border;
  colorTable: colors.$color-table;
  colorGrey: colors.$color-grey;
  colorGreyLight: colors.$color-grey-light;
  colorGreyLightTwo: colors.$color-grey-light-two;
  colorGreen: colors.$color-green;
  colorYellow: colors.$color-yellow;
  colorRed: colors.$color-red;
  colorAmber: colors.$color-amber;
  colorAmberBg: colors.$color-amber-bg;
  colorAmberBorder: colors.$color-amber-border;
  colorAmberText: colors.$color-amber-text;
  colorImproveBg: colors.$color-improve-bg;
  colorImproveBorder: colors.$color-improve-border;
  colorImproveText: colors.$color-improve-text;
  colorWorsenBg: colors.$color-worsen-bg;
  colorWorsenBorder: colors.$color-worsen-border;
  colorWorsenText: colors.$color-worsen-text;
  boxShadow: variables.$box-shadow;
  drawerWidthOpen: variables.$drawer-width-open;
  drawerWidthClose: variables.$drawer-width-close;
  fontMain: variables.$font-main;
}
:export {
  @each $key, $value in breakpoints.$breakpoints {
    #{string.unquote($key)}: $value;
  }
}
